import Layout from "layouts/DashboardLayout.jsx";

import MyGroceryList from '../views/MyGroceryList';
import PrintGroceryList from '../views/PrintGroceryList';
import PdfDownload from "../components/share/PdfDownload";

const indexRoutes = [
  { path: "/myGroceryList/:id", component: MyGroceryList},
  { path: "/printGroceryList", component: PrintGroceryList},
  { path: '/pdfDownload/:id', component: PdfDownload},
  { path: "/", component: Layout }
];

export default indexRoutes;